import WebAudioFontPlayer from 'webaudiofont';
import { fretBoard, Note, strings } from '../constants/bass';

export interface PlayNotesOptions {
    bpm: number;
    notes: Array<Note>;
    repeat?: boolean;
}

export function getNote(string: strings, fret: number, duration: number) {
    return {
        pitch: fretBoard[string][fret],
        duration: duration
    }
}

export function getRest(duration: number) {
    return {
        duration: duration
    }
}

export function getNotesLengthWhenPlayed(opts: PlayNotesOptions): number {
    var bpm = opts.bpm || 100;
    var notes = opts.notes || [];

    var startTime = 0;
    var barLength = getBarLength(bpm);

    for (var i = 0; i < notes.length; i++) {
        var note = notes[i];
        var duration = note.duration * barLength;

        startTime += duration;
    };

    return startTime;
}

export function getBarLength(bpm: number) {
    return 60 / bpm * 4; // in seconds
}

export default class BassService {
    audioContext: AudioContext;
    player: WebAudioFontPlayer;
    preset: any;
    presetName: string = '';
    timeoutId: any;

    constructor() {
        console.log('New BassService');
        const AudioContextFunc = window.AudioContext || window.webkitAudioContext;
        this.audioContext = new AudioContextFunc();
        this.player = new WebAudioFontPlayer();
    }

    playNotes(opts: PlayNotesOptions, preset: any, presetName: string, isFirstTime = true) {
        this.stop();
        this.preset = preset;
        this.presetName = presetName;
        this.player.loader.decodeAfterLoading(this.audioContext, this.presetName);

        var bpm = opts.bpm || 100;
        var notes = opts.notes || [];

        if (bpm <= 0 || notes.length === 0) {
            console.log('Nothing to play');
            return;
        }

        this.audioContext.resume();
        var startTime = this.audioContext.currentTime + .1; // in seconds
        var barLength = getBarLength(bpm);

        for (var i = 0; i < notes.length; i++) {
            var note = notes[i];
            var duration = note.duration * barLength;

            if (note.pitch) {
                this.player.queueWaveTable(this.audioContext, this.audioContext.destination, this.preset, startTime, note.pitch, duration);
            }

            // update timer
            startTime += duration;
        };

        // workaround for empty buffer bug
        if (isFirstTime) {
            setTimeout(() => { this.playNotes(opts, preset, presetName, false) }, 60);
            return;
        }

        if (opts.repeat) {
            const length = (getNotesLengthWhenPlayed(opts) + barLength) * 1000;
            this.timeoutId = setTimeout(() => { this.playNotes(opts, preset, presetName, false) }, length);
        }
    }

    stop() {
        this.player.cancelQueue(this.audioContext);
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    dispose() {
        this.stop();
    }
}
